import { formatDate } from "@angular/common";
import { CalcTemplate } from "./calctemplate";
import { Component_MAWP } from "./component_mawp";
import { Component_MAEP } from "./component_maep"
import { Component_MFH } from "./component_mfh";
import { LTA_module } from "./lta_module";
import { Utility } from "./utility";
import { FormControl } from "@angular/forms";
import { GMLReportService } from "./gml_report.service";

export class GML_module {
  public static validationMessage = [];
  public static intanalysis_type: number = -1; // Analysis type, 0 - average measured thickness, 1 - MAWP and MFH
  public static tc_from_gml: number = -1; // temp variable to hold tc value for external pressure calculation
  public static sngtam: number = -1; // average measured thickness
  public static gmlCalcResult = "";
  public static isExternalLoading: boolean = false; // Flag to indicate loading type: false = Internal, true = External

  // Level 2 Assessment properties
  public static intAssessmentLevel: number = 0; // 0 = Level 1 only, 1 = Level 1 and Level 2
  public static isSupplementalLoadsAvailable: boolean = false; // Whether supplemental loads are provided
  public static sngM_bending: number = -1; // Bending Moment from wind or seismic loading (lb-ft / N-m)
  public static sngF_weight: number = -1; // Weight of vessel (lb / N)
  public static sngAlpha_cone: number = 0; // Apex Angle for conical shells (degrees), 0 for cylindrical
  public static sngF_ml: number = -1; // Vertical load acting at lower edge of metal loss, Fml (lb / N)
  public static sngM_ml: number = -1; // Bending moment acting at lower edge of metal loss, Mml (ft-lb / kN-m)
  public static sng_t_sl_calc: number = 0; // Calculated supplemental load thickness
  public static sng_tmin_L: number = -1; // Minimum required thickness for axial stress (longitudinal)
  public static sng_MAWPr_L: number = -1; // MAWP including supplemental loads
  public static sng_tmin_L2: number = -1; // Level 2 tmin
  public static sng_MAWPr_L2: number = -1; // Level 2 MAWPr
  public static sng_MAWPr_C_raw: number = -1; // Raw MAWPr_C without stat_head subtraction

  //for saving in json file 
  public static inpt1_text:string ="";
  public static inpt2_text:string ="";
  public static inpt1:string ="";
  public static inpt2:string ="";
  public static Cmptype:string="";
  public static typearesultval:string="";
  public static typeAradsel:string="";
  public static unitType:string="";
  public static typedamageval:string="";
   // Add a loading type property: 0 = Internal, 1 = External
  public static intLoadingType: number = -1;
  static inttypeA_passorfail: number;
  GML_module() {
    GML_module.GML_initialize();
  }

  public static GML_initialize(): void {
    //initialize all the variables
    this.intanalysis_type = -1;
    this.sngtam = -1;
    LTA_module.sngtmm = -1;
    CalcTemplate.sngFCAml = -1;
    this.gmlCalcResult = "";
    this.isExternalLoading = false;
    // Level 2 reset
    this.intAssessmentLevel = 0;
    this.isSupplementalLoadsAvailable = false;
    this.sngM_bending = -1;
    this.sngF_weight = -1;
    this.sngAlpha_cone = 0;
    this.sngF_ml = -1;
    this.sngM_ml = -1;
    this.sng_t_sl_calc = 0;
    this.sng_tmin_L = -1;
    this.sng_MAWPr_L = -1;
    this.sng_tmin_L2 = -1;
    this.sng_MAWPr_L2 = -1;
    this.sng_MAWPr_C_raw = -1;
  }

  public static ReturnGMLValuesAsHTML(): string {
    let result =
      "intanalysis_type: " +
      this.intanalysis_type +
      "</br>" +
      "sngtam: " +
      this.sngtam;

    return result;
  }

 public static ExportToJson(radioButtonDI: string): string {
    //shameer-start
    if(parseInt(localStorage.getItem("TypeAradioselection")) == 1) // for vertical popup
    {
      // for Vertical Vessel

        const userinputs = localStorage.getItem('verticalinputs');
        const Input_data = userinputs ? JSON.parse(userinputs) : null;
        const a1 = Input_data.inputvalue1;
        const a2 = Input_data.inputvalue2;

       // this is used for saving in json file
        this.inpt1 = a1;
        this.inpt2 = a2;

        if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
        {
        this.inpt1_text = "Vertical Location of the Flaw, H (inch)" ;
        this.inpt2_text = "nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
        }
        else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
        {
          this.inpt1_text = "Vertical Location of the Flaw, H*  (mm) *" ;
          this.inpt2_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";             
        }

      } 
      else if (parseInt(localStorage.getItem("TypeAradioselection")) == 2) //for horizontal popup
       {
          //for Horizontal Vessel

          const userinputs = localStorage.getItem('horizontalinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
 
           // this is used for saving in json file
            this.inpt1 = a1;
            this.inpt2 = a2;

            if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
            {
              this.inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *" ;
              this.inpt2_text = "Distance between saddle supports Lss  (inch) *";
            }
            else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
            {
              this.inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *" ;
              this.inpt2_text = "nDistance between saddle supports Lss  (mm) *";
            }

        }
        else if(parseInt(localStorage.getItem("TypeAradioselection")) == 3) //for Carbon and low alloy
       {
          const userinputs = localStorage.getItem('carbonsteelinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
           
                  // this is used for saving in json file
                  this.inpt1 = a1;
                  this.inpt2 = a2;

                  if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℉)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (inch)";
                  }
              else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℃)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (mm)";
                  }

         }
       
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 4) //for High alloy and Nonferrous
           {
                //for High Alloy and Nonferrous Steel

              const userinputs = localStorage.getItem('highalloyinputs');
              const Input_data = userinputs ? JSON.parse(userinputs) : null;
              const a1 = Input_data.inputvalue1;
              const a2 = Input_data.inputvalue2;

                // this is used for saving in json file
                  this.inpt1 = a1;
                  this.inpt2 = a2;

                  if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0) //us customary
                  {
                    this.inpt1_text  = "Maximum Operating Temperature, Top  (℉)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (inch)";
                  }
                  else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1) //si units
                  {
                    this.inpt1_text = "Maximum Operating Temperature, Top  (℃)" ;
                    this.inpt2_text = "Pipe Nominal size, NPS  (mm)";
                  }
      
             }
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 5) //for Spherical Components
           {
                  // this is used for saving in json file
 		              this.inpt1 = "";
                  this.inpt2 = "";
                  this.inpt1_text = "" ;
                  this.inpt2_text = "";
           }
        if(radioButtonDI.toString().toUpperCase() == "radioButton1_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAWP.getComponentType(Component_MAWP.intEquip);
        else if(radioButtonDI.toString().toUpperCase() == "radioButton2_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAEP.getComponentType(Component_MAEP.intEquip);


        if(parseInt(localStorage.getItem("TypeAPassorFail")) == 0) 
        {
            this.typearesultval = "FAIL";
        }
        else if(parseInt(localStorage.getItem("TypeAPassorFail")) == 1) 
        {
          this.typearesultval = "PASS";
        }
        

        if(parseInt(localStorage.getItem("TypeAradioselection"))== 1)
        {
          this.typeAradsel ="VerticalVessel";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 2)
        {
            this.typeAradsel ="HorizonalVessel";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 3)
        {
              this.typeAradsel ="CarbonandLowAllySteelPiping";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 4)
        {
                this.typeAradsel ="HighAlloyNonFerrousSteelPiping";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 5)
        {
          this.typeAradsel ="SphericalComponents";
        }
        else  if(parseInt(localStorage.getItem("TypeAradioselection"))== 7)
        {
          this.typeAradsel ="CylindricalAtmosphericStorageTankShellCourses";
        }

        const isTankAssessment =
          Number(localStorage.getItem("TypeAradioselection")) === 7;
        if ((!this.typeAradsel || this.typeAradsel.trim() === "") && isTankAssessment) {
          this.typeAradsel = "CylindricalAtmosphericStorageTankShellCourses";
        }

        if(Component_MAWP.intUnit_select == 0 || Component_MAEP.intUnit_select == 0 || Component_MFH.intUnit_select == 0)
        {
          this.unitType = "US";
        }
        else if(Component_MAWP.intUnit_select == 1 || Component_MAEP.intUnit_select == 1 || Component_MFH.intUnit_select == 1)
        {
          this.unitType = "SI";
        }
      
    //shameer-end
        this.typedamageval = radioButtonDI;

        const resolvedTypeARadioSelect =
          this.typeAradsel && this.typeAradsel.trim() !== ""
            ? this.typeAradsel
            : (isTankAssessment ? "CylindricalAtmosphericStorageTankShellCourses" : "VerticalVessel");
        const resolvedComponentType =
          (this.Cmptype && this.Cmptype.trim() !== "")
            ? this.Cmptype
            : (isTankAssessment ? "Tank" : "");

        this.typeAradsel = resolvedTypeARadioSelect;
        this.Cmptype = resolvedComponentType;
        const dataToExport: any = {};

      const isGmlTank = Number(localStorage.getItem("TypeAradioselection")) === 7;

      if (!isGmlTank && radioButtonDI?.toString().toUpperCase() === "RADIOBUTTON1_DI_ENABLED") {
        dataToExport.Component_MAWP = { ...Component_MAWP };
      } else if (!isGmlTank && radioButtonDI?.toString().toUpperCase() === "RADIOBUTTON2_DI_ENABLED") {
        dataToExport.Component_MAEP = { ...Component_MAEP };
      }

      // Always include these modules
      if (!isGmlTank) {
        dataToExport.LTA_module = { ...LTA_module };
      }
      dataToExport.CalcTemplate = { ...CalcTemplate };
      const componentMfhData: any = { ...Component_MFH };
      if (isGmlTank) {
        componentMfhData.intEquip = 8;
      } else {
        delete componentMfhData.intEquip;
      }
      dataToExport.Component_MFH = componentMfhData;
      const gmlDataToExport: any = { ...GML_module };
      if (isGmlTank) {
        gmlDataToExport.sngtmm = LTA_module.sngtmm;
      } else {
        delete gmlDataToExport.sngtmm;
      }
      dataToExport.GML_module = {
        ...gmlDataToExport,
        strD_iclass: 0,
        typeAradsel: resolvedTypeARadioSelect,
        Cmptype: resolvedComponentType,
        unitType: this.unitType
      };
      dataToExport.strD_iclass = 0;
      dataToExport.strD_class = "GML";

      dataToExport.typeaData = {
        typeAresult: this.typearesultval,
        TypeARadioSelect: resolvedTypeARadioSelect,
        Input1_text: this.inpt1_text,
        Input1_value: this.inpt1,
        Input2_text: this.inpt2_text,
        Input2_value: this.inpt2,
        ComponetType: resolvedComponentType,
        TypeofUnit: this.unitType
      };


    const jsonData = JSON.stringify(dataToExport);

    return jsonData;
  }

  public static ImportFromJson(jsonDataResult): void {
    
    Component_MAWP.MAWP_initialize();
    Component_MAEP.MAEP_initialize();
    Component_MFH.MFH_initialize();
    GML_module.GML_initialize();

    Object.assign(Component_MAWP, jsonDataResult.Component_MAWP);
    Object.assign(Component_MAEP, jsonDataResult.Component_MAEP);
    Object.assign(Component_MFH, jsonDataResult.Component_MFH);
    Object.assign(CalcTemplate, jsonDataResult.CalcTemplate);
    Object.assign(LTA_module, jsonDataResult.LTA_module);
    Object.assign(GML_module, jsonDataResult.GML_module);

    const importedTypeASelection = (
      jsonDataResult?.typeaData?.TypeARadioSelect ??
      jsonDataResult?.GML_module?.typeAradsel
    )?.toString();
    const importedComponentType = (
      jsonDataResult?.typeaData?.ComponetType ??
      jsonDataResult?.GML_module?.Cmptype
    )?.toString().toUpperCase();
    const isTankAssessment =
      importedTypeASelection === "CylindricalAtmosphericStorageTankShellCourses" ||
      importedComponentType === "TANK" ||
      Number(jsonDataResult?.Component_MFH?.intEquip) === 8;
    if (!isTankAssessment) {
      Component_MFH.intEquip = -1;
    }

    const exportedTankThickness = Number(jsonDataResult?.GML_module?.sngtmm);
    if (
      jsonDataResult?.GML_module?.sngtmm !== undefined &&
      Number.isFinite(exportedTankThickness)
    ) {
      LTA_module.sngtmm = exportedTankThickness;
    }

    const importedMfh = jsonDataResult?.Component_MFH ?? {};
    const legacyHml = Number(importedMfh.sngH_ml);
    if ((!Number.isFinite(Number(Component_MFH.sngH_f)) || Number(Component_MFH.sngH_f) < 0) && Number.isFinite(legacyHml) && legacyHml >= 0) {
      Component_MFH.sngH_f = legacyHml;
      if (!Number.isFinite(Number(CalcTemplate.sngH_f)) || Number(CalcTemplate.sngH_f) < 0) {
        CalcTemplate.sngH_f = legacyHml;
      }
    }
    if ((!Number.isFinite(Number(Component_MFH.sngH_f)) || Number(Component_MFH.sngH_f) < 0) && Number.isFinite(Number(CalcTemplate.sngH_f)) && Number(CalcTemplate.sngH_f) >= 0) {
      Component_MFH.sngH_f = Number(CalcTemplate.sngH_f);
    }
  }

  public static updateInspectionDataFormControls(
    inspectionDataFormGroup
  ): void {
    let radioButton1_DIformControl: FormControl =
      inspectionDataFormGroup.get("radioButton_DI");
    let textBox1_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox1_DI");
    let textBox2_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox2_DI");
    let textBox3_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox3_DI");
    let textBox7_DI_sngHf_formControl: FormControl =
      inspectionDataFormGroup.get("textBox7_DI_sngHf");
    let textBox3_DI_sngH_f_formControl: FormControl =
      inspectionDataFormGroup.get("textBox3_DI_sngH_f");
    let mfhFcaMlFormControl: FormControl =
      inspectionDataFormGroup.get("textBox7_DI_sngfcaML");
    let mfhHmlFormControl: FormControl =
      inspectionDataFormGroup.get("textBox3_DI_sngH_ml");
    let textBox8_DI_formControl: FormControl =
      inspectionDataFormGroup.get("textBox8_DI");

    const isMfhAssessment =
      Number(localStorage.getItem("TypeAradioselection")) === 7 ||
      Number(Component_MAWP.intEquip) === 8 ||
      Number(Component_MAEP.intEquip) === 8;

    if (GML_module.intanalysis_type == 0) {
      radioButton1_DIformControl.setValue("radioButton1_DI_enabled");
      radioButton1_DIformControl.enable();
    }

    else if (GML_module.intanalysis_type == 1) {
      radioButton1_DIformControl.setValue("radioButton2_DI_enabled");
      radioButton1_DIformControl.enable();
    }
    if(GML_module.intanalysis_type == 0)
    {
      if (GML_module.sngtam > 0) {
        textBox1_DI_DIformControl.setValue(GML_module.sngtam);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
        textBox1_DI_DIformControl.setValue(GML_module.sngtam);
    }

    if(GML_module.intanalysis_type == 0)
    {
      if (LTA_module.sngtmm > 0) {
        textBox2_DI_DIformControl.setValue(LTA_module.sngtmm);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
      textBox2_DI_DIformControl.setValue(LTA_module.sngtmm);
    }
    
    
    if (isMfhAssessment) {
      if (CalcTemplate.sngFCAml > -1 && textBox7_DI_sngHf_formControl) {
        textBox7_DI_sngHf_formControl.setValue(CalcTemplate.sngFCAml);
      }
      if (CalcTemplate.sngFCAml > -1 && mfhFcaMlFormControl) {
        mfhFcaMlFormControl.setValue(CalcTemplate.sngFCAml);
      }

      const hMl = Number.isFinite(Number(Component_MFH.sngH_f)) && Number(Component_MFH.sngH_f) >= 0
        ? Number(Component_MFH.sngH_f)
        : Number(CalcTemplate.sngH_f);
      if (Number.isFinite(hMl) && hMl >= 0) {
        textBox3_DI_sngH_f_formControl?.setValue(hMl);
        mfhHmlFormControl?.setValue(hMl);
      }

      if (Number.isFinite(Number(Component_MFH.sngH_w)) && Number(Component_MFH.sngH_w) >= 0 && textBox8_DI_formControl) {
        textBox8_DI_formControl.setValue(Component_MFH.sngH_w);
      }
    } else if(GML_module.intanalysis_type == 0)
    {
      if (CalcTemplate.sngFCAml > -1) {
        textBox3_DI_DIformControl.setValue(CalcTemplate.sngFCAml);
        textBox7_DI_sngHf_formControl?.setValue(CalcTemplate.sngFCAml);
      }
    }
    else if(GML_module.intanalysis_type == 1)
    {
      textBox3_DI_DIformControl.setValue(CalcTemplate.sngFCAml);
      textBox7_DI_sngHf_formControl?.setValue(CalcTemplate.sngFCAml);
    }
  }

  public static check_GML_Data(inspectionDataFormGroup): boolean {
    let messagesValidationsList: string[] = [];
    let msg: string;

    // Check Analysis Type
    const analysisTypeValid = this.checkAnalysisType(
      inspectionDataFormGroup,
      messagesValidationsList
    );

    // Check TAM
    const tamValid = this.checkTam(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Check tam against tnom (applies to vessels and tanks)
    const tamAgainstTnomValid = this.checkTamAgainstTnom(
      inspectionDataFormGroup,
      messagesValidationsList
    );

    // Check TMM
    const tmmValid = this.checkTmm(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Check FCAml
    const fcAmlValid = this.checkFCAml(
      inspectionDataFormGroup,
      messagesValidationsList,
      msg
    );

    // Combine all validation results
    const overallValidation =
      analysisTypeValid && tamValid && tamAgainstTnomValid && tmmValid && fcAmlValid;
    this.validationMessage = !overallValidation ? messagesValidationsList : [];
    return overallValidation;
  }

  private static checkAnalysisType(
    inspectionDataFormGroup,
    messagesValidationsList: string[]
  ): boolean {
    let pass_flag = true;
    let radioButton_DIformControl: FormControl =
      inspectionDataFormGroup.get("radioButton_DI");

    if (radioButton_DIformControl.enabled) {
      if (
        GML_module.intanalysis_type != 0 &&
        GML_module.intanalysis_type != 1
      ) {
        messagesValidationsList.push("Type of Analysis must be selected.\n");
        pass_flag = false;
      }
    }
    return pass_flag;
  }

  private static checkTam(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
   let pass_flag = true;
   let textBox2_DI_DIformControl: FormControl =
    inspectionDataFormGroup.get("textBox2_DI");

  if (textBox2_DI_DIformControl.enabled) {
    if (!Utility.isTextADouble(textBox2_DI_DIformControl.value)) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm -" + msg + "\n"
      );
      pass_flag = false;
    } else if (LTA_module.sngtmm <= 0) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm - cannot be less than or equal to zero.\n"
      );
      pass_flag = false;
    } else if (LTA_module.sngtmm > this.getActiveNominalThickness()) {
       messagesValidationsList.push(
         "Minimum measured thickness, tmm - cannot be greater than tnom\n"
      );
       pass_flag = false;
    } else if (LTA_module.sngtmm > GML_module.sngtam) {
      messagesValidationsList.push(
        "Minimum measured thickness, tmm - cannot be greater than Average measured thickness tam\n"
      );
      pass_flag = false;
    }
  }
  return pass_flag;
  }

  private static checkTamAgainstTnom(
    inspectionDataFormGroup,
    messagesValidationsList: string[]
  ): boolean {
    const tamFormControl: FormControl =
      inspectionDataFormGroup.get("textBox1_DI");

    if (!tamFormControl?.enabled) {
      return true;
    }

    if (!Utility.isTextADouble(tamFormControl.value)) {
      return true;
    }

    const tam = parseFloat(tamFormControl.value);
    const tnom = this.getActiveNominalThickness();

    if (Number.isFinite(tam) && tnom > 0 && tam > tnom) {
      messagesValidationsList.push(
        "Average measured thickness (tam) cannot be greater than nominal thickness (tnom).\n"
      );
      return false;
    }

    return true;
  }
	// Add this helper method to handle all component selections
  private static getActiveComponent(): typeof Component_MAWP | typeof Component_MAEP {
    if (Component_MAWP.strRadio === 1 && Component_MAEP.strRadio === 1) {
      return Component_MAEP; // External pressure
    } else {
      return Component_MAWP; // Internal pressure or default
    }
  }
    // Add this method to get the correct sngtnom value based on radio button
  private static getActiveNominalThickness(): number {
    const activeComponent = this.getActiveComponent();
    if (activeComponent.sngtnom > 0) {
      return activeComponent.sngtnom;
    }

    if (Component_MFH.sngtnom > 0) {
      return Component_MFH.sngtnom;
    }

    return activeComponent.sngtnom;
  }
  private static checkTmm(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
    let pass_flag = true;
    let textBox2_DI_DIformControl: FormControl =
      inspectionDataFormGroup.get("textBox2_DI");

    if (textBox2_DI_DIformControl.enabled) {
      if (!Utility.isTextADouble(textBox2_DI_DIformControl.value)) {
        messagesValidationsList.push(
          "Minimum measured thickness, tmm -" + msg + "\n"
        );
        pass_flag = false;
      } else if (LTA_module.sngtmm <= 0) {
        messagesValidationsList.push(
          "Minimum measured thickness, tmm - cannot be less than or equal to zero.\n"
        );
        pass_flag = false;
       } //else if (LTA_module.sngtmm > this.getActiveNominalThickness()) {
         //messagesValidationsList.push(
          // "Minimum measured thickness, tmm - cannot be greater than tnom\n"
       // );
        // pass_flag = false;
     // } 
      //else if (LTA_module.sngtmm > GML_module.sngtam) {
      //  messagesValidationsList.push(
       //   "Minimum measured thickness, tmm - cannot be greater than Average measured thickness tam\n"
      //  );
      //  pass_flag = false;
     // }
    }

    

    return pass_flag;
  }

  private static checkFCAml(
    inspectionDataFormGroup,
    messagesValidationsList,
    msg: string
  ): boolean {
    let pass_flag = true;
    let fcaFormControl: FormControl =
      inspectionDataFormGroup.get("textBox7_DI_sngHf");

    if (fcaFormControl?.enabled) {
      if (!Utility.isTextADouble(fcaFormControl.value)) {
        messagesValidationsList.push(
          "Future corrosion allowance inside the damage area, FCAml - must be a valid number.\n"
        );
        pass_flag = false;
      } else if (CalcTemplate.sngFCAml < 0) {
        messagesValidationsList.push(
          "FCAml - cannot be less than zero.\n"
        );
        pass_flag = false;
      }
      else if (CalcTemplate.sngFCAml >= LTA_module.sngtmm) {
        messagesValidationsList.push(
          "FCAml - cannot be greater than or equal to tmm.\n"
        );
        pass_flag = false;
      }
    }
    return pass_flag;
  }
  
public static GML_calc(): string {
  // Check loading type: 0 = Internal, 1 = External
  if (GML_module.intLoadingType === 1) {
    // External pressure logic
    return this.GML_calc_externalPressure();
  } else {
    // Internal pressure logic (existing)
    return this.GML_calc_internalPressure();
  }
}
// Calculate GML for external pressure
  public static GML_calc_externalPressure(): string {
    
    let aa: number, bb: number, cc: number, t_lim: number;
    let sngMWAP_localnew_r: number; // added by shameer
    let key1: number, key2: number, key3: number;

    let result = "";

    // First criterion -- tam - FCAml >= tmin or MAWPr >= P_d / MFH_r >= MFH_d
    if (GML_module.intanalysis_type === 0) {
      // average thickness approach
      aa = GML_module.sngtam - CalcTemplate.sngFCAml;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = aa.toFixed(3);
        Component_MAEP.buffer1 = Component_MAEP.sngtmin.toFixed(3);

        //added by shameer
        let pp: number;
        pp = Component_MAEP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        pp = Utility.roundDouble(pp, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= pp) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAEP.buffer} inch  >=  tmin = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAEP.buffer} inch  <  tmin = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = aa.toFixed(1);
        Component_MAEP.buffer1 = Component_MAEP.sngtmin.toFixed(1);

        // added by shameer
        let qq: number;
        qq = Component_MAEP.sngtmin // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        qq = Utility.roundDouble(qq, 1)
        aa = Utility.roundDouble(aa, 1);

        if (aa >= qq) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAEP.buffer} mm  >=  tmin = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAEP.buffer} mm  <  tmin = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // MAWP approach - intanalysis_type = 1
      if (Component_MAEP.intEquip !== 6) {
        // not tanks
        this.tc_from_gml = this.sngtam - CalcTemplate.sngFCAml;
        // adding by shameer
        switch (Component_MAEP.intEquip) {
          case 0: // for cylinder
           // Call the new function with your tc value
           sngMWAP_localnew_r = Component_MAEP.cal_MAEPR_external(this.tc_from_gml);
            break;
          case 1:
            break;
        }

        if (Component_MAEP.intUnit_select === 0) {
          // US customary
          Component_MAEP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAEP.buffer1 = Component_MAEP.sngP_d.toFixed(2);
        } else {
          // SI
          Component_MAEP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAEP.buffer1 = Component_MAEP.sngP_d.toFixed(2);
        }

        if (Component_MAEP.intUnit_select === 0) {
          // US Customary
          if (parseFloat(Component_MAEP.buffer) >= Component_MAEP.sngP_d) {
            key1 = 0;
            result += `MAEP_r based on tam - FCAml = ${Component_MAEP.buffer} psi  >=  Equipment Design External Pressure, P_d = ${Component_MAEP.buffer1} psi </br>`;
          } else {
            key1 = 1;
            result += `MAEP_r based on tam - FCAml = ${Component_MAEP.buffer} psi  <  Equipment Design External Pressure, P_d = ${Component_MAEP.buffer1} psi  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (parseFloat(Component_MAEP.buffer) >= Component_MAEP.sngP_d) {
            key1 = 0;
            result += `MAEP_r based on tam - FCAml = ${Component_MAEP.buffer} MPa  >=  Equipment Design External Pressure, P_d = ${Component_MAEP.buffer1} MPa </br>`;
          } else {
            key1 = 1;
            result += `MAEP_r based on tam - FCAml = ${Component_MAEP.buffer} MPa  <  Equipment Design External Pressure, P_d = ${Component_MAEP.buffer1} MPa  <font color="red">*Fail*</font> </br>`;
          }
        }
      } else {
        // tanks
        CalcTemplate.sngMFH_r = CalcTemplate.sngMFH;
        Component_MAEP.buffer = CalcTemplate.sngMFH_r.toFixed(3);
        Component_MAEP.buffer1 = CalcTemplate.sngMFH_d.toFixed(3);
                  const H_L = Component_MFH.sngH_L;
          console.log(`H_L is equal to: ${H_L}`);
        if (Component_MAEP.intUnit_select === 0) {
          // US Customary

          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} ft  >=  Design MFH = ${Component_MAEP.buffer1} ft </br>`;
            console.log(`H_L is equal to: ${H_L}`);
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} ft  <  Design MFH = ${Component_MAEP.buffer1} ft  <font color="red">*Fail*</font> </br>`;
            console.log(`H_L is equal to: ${H_L}`);
          }
        } else {
          // SI
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} m  >=  Design MFH = ${Component_MAEP.buffer1} m </br>`;
            
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAEP.buffer} m  <  Design MFH = ${Component_MAEP.buffer1} m  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    }
    // Second criterion -- tmm - FCAml >= limiting t based on equipment type
    if (Component_MAEP.intEquip !== 6) {
      // non-tank
      t_lim = 0.2 * Component_MAEP.sngtnom;
    } else {
      // tank
      t_lim = 0.2 * Component_MAEP.sngtc;
    }

    const typeARadio = parseInt(localStorage.getItem("TypeAradioselection") || "0", 10);
    const isTypeAPipingSelection = typeARadio === 3 || typeARadio === 4;
    const isPipingComponent =
      Component_MAEP.intEquip === 5 ||
      Component_MAEP.intEquip === 6 ||
      Component_MAEP.intEquip === 7 ||
      isTypeAPipingSelection;

    if (Component_MAEP.intUnit_select === 0) {
      // US Customary
      console.log("Component_MAWP.intEquip " + Component_MAEP.intEquip);
      if (!isPipingComponent) {
        // non-piping
        if (t_lim < 0.1) t_lim = 0.1;
        Component_MAEP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.1 inch] = ${Component_MAEP.buffer} inch </br>`;
      } else {
        // piping
        if (t_lim < 0.05) t_lim = 0.05;
        Component_MAEP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.05 inch] = ${Component_MAEP.buffer} inch </br>`;
      }
    } else {
      // SI
      if (!isPipingComponent) {
        // non-piping
        if (t_lim < 2.5) t_lim = 2.5;
        Component_MAEP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 2.5 mm] = ${Component_MAEP.buffer} mm </br>`;
      } else {
        // piping
        if (t_lim < 1.3) t_lim = 1.3;
        Component_MAEP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 1.3 mm] = ${Component_MAEP.buffer} mm </br>`;
      }
    }
    // added by shameer - start
    if (Component_MAEP.intEquip !== 8) {
      // non tank
      let aa = 0.9 * GML_module.sngtam;
      let bb = LTA_module.sngtmm - CalcTemplate.sngFCAml;
      let cc = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAEP.sngtmin = Utility.roundDouble(Component_MAEP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk;
        kk = Component_MAEP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to new variable
        kk = Utility.roundDouble(kk, 3);

        Component_MAEP.buffer = cc.toFixed(3);
        Component_MAEP.buffer1 = kk.toFixed(3);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAEP.buffer1 = aa.toFixed(3);
            result +=
              "tam - FCAml = " +
              Component_MAEP.buffer +
              " inch >=  tmin and tmm >= 0.9 * tam = " +
              Component_MAEP.buffer1 +
              " inch </br>";
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAEP.buffer1 = bb.toFixed(3);
              result +=
                "tam - FCAml = " +
                Component_MAEP.buffer +
                " inch >=  tmin and tmm - FCAml = " +
                Component_MAEP.buffer1 +
                " inch >= tmin  </br>";
              key3 = 0;
            } else {
              Component_MAEP.buffer = bb.toFixed(3);
              Component_MAEP.buffer1 = aa.toFixed(3);
              result +=
                "tmm - FCAml = " +
                Component_MAEP.buffer +
                " inch <  tmin and tmm < 0.9 * tam = " +
                Component_MAEP.buffer1 +
                ` inch <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result +=
        //     "tam - FCAml = " +
        //     Component_MAWP.buffer +
        //     " inch <  tmin = " +
        //     Component_MAWP.buffer1 +
        //     ` inch <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      } else {
        // SI

        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAEP.sngtmin = Utility.roundDouble(Component_MAEP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk: number;
        kk = Component_MAEP.sngtmin;
        kk = Utility.roundDouble(kk, 3);

        Component_MAEP.buffer = cc.toFixed(1);
        Component_MAEP.buffer1 = kk.toFixed(1);
        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAEP.buffer1 = aa.toFixed(1);
            result += `tam - FCAml = ${Component_MAEP.buffer} mm >=  tmin and tmm >= 0.9 * tam = ${Component_MAWP.buffer1} mm </br>`;
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAEP.buffer1 = bb.toFixed(1);
              result += `tam - FCAml = ${Component_MAEP.buffer} mm >=  tmin and tmm - FCAml = ${Component_MAWP.buffer1} mm >= tmin  </br>`;
              key3 = 0;
            } else {
              Component_MAEP.buffer = bb.toFixed(1);
              Component_MAEP.buffer1 = aa.toFixed(1);
              result += `tmm - FCAml = ${Component_MAEP.buffer} mm <  tmin and tmm < 0.9 * tam = ${Component_MAWP.buffer1} mm <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result += `tam - FCAml = ${Component_MAWP.buffer} mm <  tmin = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      }
    }
    //added by shameer - end

    if (Component_MAWP.intEquip !== 6) {
      // non tank
      let aa = 0.5 * Component_MAEP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAEP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  >=  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  <  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAEP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  >=  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  <  max[0.5 * tmin, t_lim] = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // tank
      let aa = 0.6 * Component_MAEP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAEP.intUnit_select === 0) {
        // US Customary
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAEP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  >=  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} inch  <  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAEP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAEP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  >=  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAEP.buffer} mm  <  max[0.6 * tmin, t_lim] = ${Component_MAEP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    }
    if (key1 === 0 && key2 === 0) {
      if (key3 === 1) {
        Component_MAEP.strD_result = "Fail";
        result += `</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>`;
      } else {
        Component_MAEP.strD_result = "Pass";
        result +=
          '</br><font color="blue">General Metal Loss passed Level 1 assessment.</font>  </br>';
      }
    } else {
      Component_MAEP.strD_result = "Fail";
      result +=
        '</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>';
    }

    this.gmlCalcResult = result;

    return result;
  }

  // Calculate GML for internal pressure
  public static GML_calc_internalPressure(): string {
   
    let aa: number, bb: number, cc: number, t_lim: number;
    let sngMWAP_localnew_r: number; // added by shameer
    let key1: number, key2: number, key3: number;

    let result ='Level 1:</br>';

    // Determine level label for display
    const levelLabel = this.intAssessmentLevel === 1 ? ' (Level 1)' : '';

    // First criterion -- tam - FCAml >= tmin or MAWPr >= P_d / MFH_r >= MFH_d
    if (GML_module.intanalysis_type === 0) {
      // average thickness approach
      aa = GML_module.sngtam - CalcTemplate.sngFCAml;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = aa.toFixed(3);
        Component_MAWP.buffer1 = Component_MAWP.sngtmin.toFixed(3);

        //added by shameer
        let pp: number;
        pp = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        pp = Utility.roundDouble(pp, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= pp) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAWP.buffer} inch  >=  tmin${levelLabel} = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAWP.buffer} inch  <  tmin${levelLabel} = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = aa.toFixed(1);
        Component_MAWP.buffer1 = Component_MAWP.sngtmin.toFixed(1);

        // added by shameer
        let qq: number;
        qq = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to a new variable
        qq = Utility.roundDouble(qq, 3);
        aa = Utility.roundDouble(aa, 3);

        if (aa >= qq) {
          key1 = 0;
          result += `tam - FCAml = ${Component_MAWP.buffer} mm  >=  tmin${levelLabel} = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key1 = 1;
          result += `tam - FCAml = ${Component_MAWP.buffer} mm  <  tmin${levelLabel} = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      console.log("Component_MAWP.intEquip " + Component_MAWP.intEquip);
      console.log("Component_MAWP " + Component_MAWP);
      // MAWP approach - intanalysis_type = 1
      if (Component_MAWP.intEquip !== 6) {
        // not tanks

        // adding by shameer
        switch (Component_MAWP.intEquip) {
          case 0: // for cylinder
            sngMWAP_localnew_r =
              (Component_MAWP.sngS_stress *
                Component_MAWP.sngE_L *
                (GML_module.sngtam - CalcTemplate.sngFCAml)) /
                (Component_MAWP.sngID / 2.0 +
                  0.6 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
              Component_MAWP.sngp_H;
            break;
        case 1: // for cone
  aa = (Component_MAWP.sngalpha / 360.0) * Math.PI;
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml) *
      Math.cos(aa)) /
      (Component_MAWP.sngID +
        1.2 *
          (GML_module.sngtam - CalcTemplate.sngFCAml) *
          Math.cos(aa)) -
    Component_MAWP.sngp_H;
  break;

case 2: // for sphere
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngID / 2.0 +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;
case 3: // ASME 2-to-1 head
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngID +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 4: // F&D head
  Component_MAWP.sngID =
    2.0 *
    (Component_MAWP.sngIDo +
      Component_MAWP.sngLOSSi +
      Component_MAWP.sngFCAi);
  aa =
    0.25 *
    (3.0 +
      Math.sqrt(Component_MAWP.sngID / 2.0 / Component_MAWP.sngrk));
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (aa * (Component_MAWP.sngID / 2) +
        0.2 * (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 5: // B31 Piping
  sngMWAP_localnew_r =
    (2.0 *
      Component_MAWP.sngS_stress *
      Component_MAWP.sngE_L *
      (GML_module.sngtam - CalcTemplate.sngFCAml)) /
      (Component_MAWP.sngOD -
        2.0 *
          Component_MAWP.sngY_b *
          (GML_module.sngtam - CalcTemplate.sngFCAml)) -
    Component_MAWP.sngp_H;
  break;

case 6:
  break;
        }

        if (Component_MAWP.intUnit_select === 0) {
          // US customary
          Component_MAWP.buffer = sngMWAP_localnew_r.toFixed(1); // modified by shameer
          Component_MAWP.buffer1 = Component_MAWP.sngP_d.toFixed(1);
        } else {
          // SI
          Component_MAWP.buffer = sngMWAP_localnew_r.toFixed(2); // modified by shameer
          Component_MAWP.buffer1 = Component_MAWP.sngP_d.toFixed(2);
        }

        if (Component_MAWP.intUnit_select === 0) {
          // US Customary
          if (sngMWAP_localnew_r >= Component_MAWP.sngP_d) {
            key1 = 0;
            result += `MAWP_r${levelLabel} based on tam - FCAml = ${Component_MAWP.buffer} psi  >=  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} psi </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r${levelLabel} based on tam - FCAml = ${Component_MAWP.buffer} psi  <  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} psi  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (sngMWAP_localnew_r >= Component_MAWP.sngP_d) {
            key1 = 0;
            result += `MAWP_r${levelLabel} based on tam - FCAml = ${Component_MAWP.buffer} MPa  >=  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} MPa </br>`;
          } else {
            key1 = 1;
            result += `MAWP_r${levelLabel} based on tam - FCAml = ${Component_MAWP.buffer} MPa  <  Equipment Design Pressure, P_d = ${Component_MAWP.buffer1} MPa  <font color="red">*Fail*</font> </br>`;
          }
        }
      } else {
        // tanks
        CalcTemplate.sngMFH_r = CalcTemplate.sngMFH;
        Component_MAWP.buffer = CalcTemplate.sngMFH_r.toFixed(3);
        Component_MAWP.buffer1 = CalcTemplate.sngMFH_d.toFixed(3);
        if (Component_MAWP.intUnit_select === 0) {
          // US Customary
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} ft  >=  Design MFH = ${Component_MAWP.buffer1} ft </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} ft  <  Design MFH = ${Component_MAWP.buffer1} ft  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          // SI
          if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
            key1 = 0;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} m  >=  Design MFH = ${Component_MAWP.buffer1} m </br>`;
          } else {
            key1 = 1;
            result += `MFH_r based on tam - FCAml = ${Component_MAWP.buffer} m  <  Design MFH = ${Component_MAWP.buffer1} m  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    }
    // Second criterion -- tmm - FCAml >= limiting t based on equipment type
    if (Component_MAWP.intEquip !== 6) {
      // non-tank
      t_lim = 0.2 * Component_MAWP.sngtnom;
    } else {
      // tank
      t_lim = 0.2 * Component_MAWP.sngtc;
    }

    if (Component_MAWP.intUnit_select === 0) {
      // US Customary
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        // non-piping
        if (t_lim < 0.1) t_lim = 0.1;
        Component_MAWP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.1 inch] = ${Component_MAWP.buffer} inch </br>`;
      } else {
        // piping
        if (t_lim < 0.05) t_lim = 0.05;
        Component_MAWP.buffer = t_lim.toFixed(3);
        result += `Limiting t, t_lim = max[0.2 * tnom, 0.05 inch] = ${Component_MAWP.buffer} inch </br>`;
      }
    } else {
      // SI
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        // non-piping
        if (t_lim < 2.5) t_lim = 2.5;
        Component_MAWP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 2.5 mm] = ${Component_MAWP.buffer} mm </br>`;
      } else {
        // piping
        if (t_lim < 1.3) t_lim = 1.3;
        Component_MAWP.buffer = t_lim.toFixed(1);
        result += `Limiting t, t_lim = max[0.2 * tnom, 1.3 mm] = ${Component_MAWP.buffer} mm </br>`;
      }
    }
    // added by shameer - start
    if (Component_MAWP.intEquip !== 8) {
      // non tank
      let aa = 0.9 * GML_module.sngtam;
      let bb = LTA_module.sngtmm - CalcTemplate.sngFCAml;
      let cc = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAWP.sngtmin = Utility.roundDouble(Component_MAWP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk;
        kk = Component_MAWP.sngtmin; // sngtmin value is not reflecting when we take directly, but it is reflecting when assigned to new variable
        kk = Utility.roundDouble(kk, 3);

        Component_MAWP.buffer = cc.toFixed(3);
        Component_MAWP.buffer1 = kk.toFixed(3);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAWP.buffer1 = aa.toFixed(3);
            result +=
              "tam - FCAml = " +
              Component_MAWP.buffer +
              " inch >=  tmin and tmm >= 0.9 * tam = " +
              Component_MAWP.buffer1 +
              " inch </br>";
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAWP.buffer1 = bb.toFixed(3);
              result +=
                "tam - FCAml = " +
                Component_MAWP.buffer +
                " inch >=  tmin and tmm - FCAml = " +
                Component_MAWP.buffer1 +
                " inch >= tmin  </br>";
              key3 = 0;
            } else {
              Component_MAWP.buffer = bb.toFixed(3);
              Component_MAWP.buffer1 = aa.toFixed(3);
              result +=
                "tmm - FCAml = " +
                Component_MAWP.buffer +
                " inch <  tmin and tmm < 0.9 * tam = " +
                Component_MAWP.buffer1 +
                ` inch <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result +=
        //     "tam - FCAml = " +
        //     Component_MAWP.buffer +
        //     " inch <  tmin = " +
        //     Component_MAWP.buffer1 +
        //     ` inch <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      } 
      else {
        // SI

        aa = Utility.roundDouble(aa, 3);
        bb = Utility.roundDouble(bb, 3);
        cc = Utility.roundDouble(cc, 3);
        LTA_module.sngtmm = Utility.roundDouble(LTA_module.sngtmm, 3);
        Component_MAWP.sngtmin = Utility.roundDouble(Component_MAWP.sngtmin, 3);
        GML_module.sngtam = Utility.roundDouble(GML_module.sngtam, 3);

        let kk: number;
        kk = Component_MAWP.sngtmin;
        kk = Utility.roundDouble(kk, 3);

        Component_MAWP.buffer = cc.toFixed(1);
        Component_MAWP.buffer1 = kk.toFixed(1);

        if (cc >= kk) {
          if (LTA_module.sngtmm >= aa) {
            Component_MAWP.buffer1 = aa.toFixed(1);
            result += `tam - FCAml = ${Component_MAWP.buffer} mm >=  tmin and tmm >= 0.9 * tam = ${Component_MAWP.buffer1} mm </br>`;
            key3 = 0;
          } else {
            if (bb >= kk) {
              Component_MAWP.buffer1 = bb.toFixed(1);
              result += `tam - FCAml = ${Component_MAWP.buffer} mm >=  tmin and tmm - FCAml = ${Component_MAWP.buffer1} mm >= tmin  </br>`;
              key3 = 0;
            } else {
              Component_MAWP.buffer = bb.toFixed(1);
              Component_MAWP.buffer1 = aa.toFixed(1);
              result += `tmm - FCAml = ${Component_MAWP.buffer} mm <  tmin and tmm < 0.9 * tam = ${Component_MAWP.buffer1} mm <font color="red">*Fail*</font> </br>`;
              key3 = 1;
            }
          }
         } else {  //commented asper new requirement as getting duplicated (1st line and 3rd line in results screen)
        //   result += `tam - FCAml = ${Component_MAWP.buffer} mm <  tmin = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        //   key3 = 1;
         }
      }
    }
    //added by shameer - end

    if (Component_MAWP.intEquip !== 6) {
      // non tank
      let aa = 0.5 * Component_MAWP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAWP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  >=  max[0.5 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  <  max[0.5 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAWP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  >=  max[0.5 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  <  max[0.5 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // tank
      let aa = 0.6 * Component_MAWP.sngtmin;
      if (aa < t_lim) aa = t_lim;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(3);
        Component_MAWP.buffer1 = aa.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  >=  max[0.6 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} inch </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} inch  <  max[0.6 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        Component_MAWP.buffer = (
          LTA_module.sngtmm - CalcTemplate.sngFCAml
        ).toFixed(1);
        Component_MAWP.buffer1 = aa.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa) {
          key2 = 0;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  >=  max[0.6 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} mm </br>`;
        } else {
          key2 = 1;
          result += `tmm - FCAml = ${Component_MAWP.buffer} mm  <  max[0.6 * tmin${levelLabel}, t_lim] = ${Component_MAWP.buffer1} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    }
    if (key1 === 0 && key2 === 0) {
      if (key3 === 1) {
        Component_MAWP.strD_result = "Fail";
        result += `</br> <font color="red">General Metal Loss failed the Level 1 assessment.  </br>Consider performing a General Metal Loss Level 2 or Level 3, or Local Metal Loss assessment.</font> </br>`;
      } else {
        Component_MAWP.strD_result = "Pass";
        result +=
          '</br><font color="blue">General Metal Loss passed Level 1 assessment.</font>  </br>';
      }
    } else {
      Component_MAWP.strD_result = "Fail";
      result +=
        '</br> <font color="red">General Metal Loss failed the Level 1 assessment.</font> </br>';
    }

    // Level 2 Assessment (if selected for Type A components)
    if (this.intAssessmentLevel === 1) {
      result += this.calcLevel2InternalPressure(key2, key3);
    }

    this.gmlCalcResult = result;

    return result;
  }
  private static getActiveReportComponent(): typeof Component_MAWP | typeof Component_MAEP {
    return GML_module.intLoadingType === 1 ? Component_MAEP : Component_MAWP;
  }

  // ==================== Level 2 Assessment Methods ====================

  /**
   * Compute tmin using the standard formula but with P * RSFa instead of P.
   * For Level 2, RSFa is multiplied to the internal pressure.
   */
  private static calc_tmin_with_RSFa(): number {
    const RSFa = CalcTemplate.sngRSF_a;
    const P = (Component_MAWP.sngP_d + Component_MAWP.sngp_H) * RSFa;
    const S = Component_MAWP.sngS_stress;
    const E_L = Component_MAWP.sngE_L;
    const R = Component_MAWP.sngID / 2.0;
    let aa: number;

    switch (Component_MAWP.intEquip) {
      case 0: // cylinder
        return P * R / (S * E_L - 0.6 * P);
      case 1: // cone
        aa = (Component_MAWP.sngalpha / 360.0) * Math.PI;
        return (P * Component_MAWP.sngID) / (2.0 * Math.cos(aa) * (S * E_L - 0.6 * P));
      case 2: // sphere
        return (P * R) / (2.0 * S * E_L - 0.2 * P);
      case 3: // ASME 2-to-1 head
        return (P * Component_MAWP.sngID) / (2.0 * S * E_L - 0.2 * P);
      case 4: // F&D head
        const M_factor = 0.25 * (3.0 + Math.sqrt(Component_MAWP.sngID / 2.0 / Component_MAWP.sngrk));
        return (P * R * M_factor) / (2.0 * S * E_L - 0.2 * P);
      case 5: // B31 piping
        const P_d_rsfa = Component_MAWP.sngP_d * RSFa;
        return (P_d_rsfa * Component_MAWP.sngOD) / (2.0 * (S * E_L + P_d_rsfa * Component_MAWP.sngY_b));
      default:
        return -1;
    }
  }

  /**
   * Compute MAWPr using tam - FCAml as the effective thickness.
   * Same formula as MAWP approach in Level 1, using the corroded measured thickness.
   */
  private static calc_MAWPr_from_tam(): number {
    const tc = GML_module.sngtam - CalcTemplate.sngFCAml;
    const S = Component_MAWP.sngS_stress;
    const E_L = Component_MAWP.sngE_L;
    const R = Component_MAWP.sngID / 2.0;
    let aa: number;

    switch (Component_MAWP.intEquip) {
      case 0: // cylinder
        return (S * E_L * tc) / (R + 0.6 * tc) - Component_MAWP.sngp_H;
      case 1: // cone
        aa = (Component_MAWP.sngalpha / 360.0) * Math.PI;
        return (2.0 * S * E_L * tc * Math.cos(aa)) / (Component_MAWP.sngID + 1.2 * tc * Math.cos(aa)) - Component_MAWP.sngp_H;
      case 2: // sphere
        return (2.0 * S * E_L * tc) / (R + 0.2 * tc) - Component_MAWP.sngp_H;
      case 3: // ASME 2-to-1 head
        return (2.0 * S * E_L * tc) / (Component_MAWP.sngID + 0.2 * tc) - Component_MAWP.sngp_H;
      case 4: // F&D head
        const M_factor = 0.25 * (3.0 + Math.sqrt(Component_MAWP.sngID / 2.0 / Component_MAWP.sngrk));
        return (2.0 * S * E_L * tc) / (M_factor * R + 0.2 * tc) - Component_MAWP.sngp_H;
      case 5: // B31 piping
        return (2.0 * S * E_L * tc) / (Component_MAWP.sngOD - 2.0 * Component_MAWP.sngY_b * tc) - Component_MAWP.sngp_H;
      default:
        return -1;
    }
  }

  /**
   * Compute MAWPr_C for Level 2 Type B component.
   * Uses E_c (circumferential) and divides by RSFa per API 579 Part 4.
   * Formula: MAWPr_C = (S * E_c * (tam - FCAml)) / ((D_cor/2 + 0.6*(tam - FCAml)) * RSFa) - Stat_head
   */
  private static calc_MAWPr_C_Level2_TypeB(): number {
    const tc = GML_module.sngtam - CalcTemplate.sngFCAml;
    const S = Component_MAWP.sngS_stress;
    const E_c = Component_MAWP.sngE_c;
    const RSFa = CalcTemplate.sngRSF_a;
    const R = Component_MAWP.sngID / 2.0; // D_cor / 2

    // For cylinder (Type B Class 1 component):
    return (S * E_c * tc) / ((R + 0.6 * tc) * RSFa) - Component_MAWP.sngp_H;
  }

  /**
   * Calculate supplemental load values: t_sl, tmin_L, MAWPr_L
   * Per API 579-1/ASME FFS-1 2021, Part 4, Level 2 for vertical vessels
   */
  private static calcAndDisplaySupplementalLoads(): string {
    let result = '';
    const S = Component_MAWP.sngS_stress;
    const E_L = Component_MAWP.sngE_L;
    const E_c = Component_MAWP.sngE_c;
    const RSFa = CalcTemplate.sngRSF_a;
    const P_d = Component_MAWP.sngP_d;
    const Do = Component_MAWP.sngOD;
    const D_cor = Component_MAWP.sngID;
    const tam = GML_module.sngtam;
    const alpha_rad = (this.sngAlpha_cone / 180.0) * Math.PI;
    const cos_alpha = Math.cos(alpha_rad);
    const F_ml = this.sngF_ml;

    // Convert bending moment to consistent units
    let M_ml_conv: number;
    if (Component_MAWP.intUnit_select === 0) {
      M_ml_conv = this.sngM_ml * 12; // lb-ft to lb-inch
    } else {
      M_ml_conv = this.sngM_ml * 1000000; // kN-m to N-mm
    }

    // Calculate t_sl (supplemental load thickness) per API 579 Eq 4.4
    const t_F = (2 * F_ml) / (S * E_L * Math.PI * (Do + D_cor) * cos_alpha);
    const t_M = (16 * Do * M_ml_conv) / (S * E_L * Math.PI * (Do + D_cor) * (Do * Do + D_cor * D_cor) * cos_alpha);
    let t_sl = t_F + t_M;
    if (t_sl < 0) {
      t_sl = 0;
    }
    // later we need to have tsl posstive and negative both, so not taking abs value here
    this.sng_t_sl_calc = t_sl;
    Component_MAWP.sngt_sl = t_sl;

    // Calculate tmin_L (longitudinal minimum required thickness including supplemental loads)
    const P_total = P_d + Component_MAWP.sngp_H;
    const tmin_L = (P_total * RSFa * D_cor / 2) / (2 * S * E_L - 1.2 * P_total * RSFa) + t_sl;
    this.sng_tmin_L = tmin_L;

    // Calculate MAWPr_L (MAWP including supplemental loads)
    const tc_eff = tam - t_sl - CalcTemplate.sngFCAml;
    const tc_cor = tam - CalcTemplate.sngFCAml; // (tam - FCAml) for denominator per API 579
    let MAWPr_L = -1;
    if (tc_eff > 0) {
      MAWPr_L = (2 * S * E_L * tc_eff) / ((D_cor / 2 + 0.6 * tc_cor) * RSFa) - Component_MAWP.sngp_H;
    }
    this.sng_MAWPr_L = MAWPr_L;

    // Store raw circumferential MAWPr for Level 2 display (using Level 2 Type B formula)
    this.sng_MAWPr_C_raw = this.calc_MAWPr_C_Level2_TypeB() + Component_MAWP.sngp_H;

    if (Component_MAWP.intUnit_select === 0) {
      // US Customary
    //  result += `Required shell thickness for supplemental loads, t_sl = ${t_sl.toFixed(3)} inch </br>`;
    //  result += `Minimum required thickness for axial stress, tmin_L = ${tmin_L.toFixed(3)} inch </br>`;
      if (MAWPr_L > 0) {
      //  result += `Maximum Allowable Working Pressure including supplemental loads, MAWPr_L = ${MAWPr_L.toFixed(1)} psi </br>`;
      }
    } else {
      // SI
     // result += `Required shell thickness for supplemental loads, t_sl = ${t_sl.toFixed(1)} mm </br>`;
     // result += `Minimum required thickness for axial stress, tmin_L = ${tmin_L.toFixed(1)} mm </br>`;
      if (MAWPr_L > 0) {
       // result += `Maximum Allowable Working Pressure including supplemental loads, MAWPr_L = ${MAWPr_L.toFixed(2)} MPa </br>`;
      }
    }

    result += '</br>';
    return result;
  }

  /**
   * Level 2 assessment for internal pressure - called after Level 1 completes.
   * Uses RSFa to modify pressure for tmin and divides MAWPr by RSFa.
   * Optionally includes supplemental loads for vertical vessels.
   */
  private static calcLevel2InternalPressure(key2_L1: number, key3_L1: number): string {
    let result = '</br>Level 2:</br>';
    const RSFa = CalcTemplate.sngRSF_a;
    let key1_L2 = 1; // 0 = pass, 1 = fail

    const hasSupplementalLoads = this.isSupplementalLoadsAvailable 
                                 

    // Calculate supplemental loads first if available
    if (hasSupplementalLoads) {
      result += this.calcAndDisplaySupplementalLoads();
    }

    if (GML_module.intanalysis_type === 0) {
      // === Average thickness approach ===
      const tmin_C_L2 = this.calc_tmin_with_RSFa();
      let tmin_final_L2 = tmin_C_L2;

      // If supplemental loads are available, take max of circumferential and longitudinal tmin
      if (hasSupplementalLoads && this.sng_tmin_L > 0) {
        tmin_final_L2 = Math.max(tmin_C_L2, this.sng_tmin_L);
      }
      this.sng_tmin_L2 = tmin_final_L2;

      const tam_minus_fca = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (hasSupplementalLoads) {
        // Show separate lines for tmin_C, t_sl, tmin_L per spec
        if (Component_MAWP.intUnit_select === 0) {
          const bufTam = tam_minus_fca.toFixed(3);
          const bufTminC = tmin_C_L2.toFixed(3);
          const bufTsl = this.sng_t_sl_calc.toFixed(3);
          const bufTminL = this.sng_tmin_L.toFixed(3);

          // Line 1: circumferential check
          if (Utility.roundDouble(tam_minus_fca, 3) >= Utility.roundDouble(tmin_C_L2, 3)) {
            key1_L2 = 0;
            result += `tam - FCAml = ${bufTam} inch  >=  tmin_C (Level 2) = ${bufTminC} inch </br>`;
          } else {
            key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} inch  <  tmin_C (Level 2) = ${bufTminC} inch  <font color="red">*Fail*</font> </br>`;
          }
          // Line 2: t_sl
          result += `Required shell thickness for supplemental loads, t_sl = ${bufTsl} inch </br>`;
          // Line 3: longitudinal check
          if (Utility.roundDouble(tam_minus_fca, 3) >= Utility.roundDouble(this.sng_tmin_L, 3)) {
            result += `tam - FCAml = ${bufTam} inch  >=  tmin_L (Level 2) = ${bufTminL} inch </br>`;
          } else {
            if (key1_L2 === 0) key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} inch  <  tmin_L (Level 2) = ${bufTminL} inch  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          const bufTam = tam_minus_fca.toFixed(1);
          const bufTminC = tmin_C_L2.toFixed(1);
          const bufTsl = this.sng_t_sl_calc.toFixed(1);
          const bufTminL = this.sng_tmin_L.toFixed(1);

          if (Utility.roundDouble(tam_minus_fca, 1) >= Utility.roundDouble(tmin_C_L2, 1)) {
            key1_L2 = 0;
            result += `tam - FCAml = ${bufTam} mm  >=  tmin_C (Level 2) = ${bufTminC} mm </br>`;
          } else {
            key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} mm  <  tmin_C (Level 2) = ${bufTminC} mm  <font color="red">*Fail*</font> </br>`;
          }
          result += `Required shell thickness for supplemental loads, t_sl = ${bufTsl} mm </br>`;
          if (Utility.roundDouble(tam_minus_fca, 1) >= Utility.roundDouble(this.sng_tmin_L, 1)) {
            result += `tam - FCAml = ${bufTam} mm  >=  tmin_L (Level 2) = ${bufTminL} mm </br>`;
          } else {
            if (key1_L2 === 0) key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} mm  <  tmin_L (Level 2) = ${bufTminL} mm  <font color="red">*Fail*</font> </br>`;
          }
        }
      } else {
        // No supplemental loads - standard single-line display
        if (Component_MAWP.intUnit_select === 0) {
          const bufTam = tam_minus_fca.toFixed(3);
          const bufTmin = tmin_final_L2.toFixed(3);
          if (Utility.roundDouble(tam_minus_fca, 3) >= Utility.roundDouble(tmin_final_L2, 3)) {
            key1_L2 = 0;
            result += `tam - FCAml = ${bufTam} inch  >=  tmin (Level 2) = ${bufTmin} inch </br>`;
          } else {
            key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} inch  <  tmin (Level 2) = ${bufTmin} inch  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          const bufTam = tam_minus_fca.toFixed(1);
          const bufTmin = tmin_final_L2.toFixed(1);
          if (Utility.roundDouble(tam_minus_fca, 1) >= Utility.roundDouble(tmin_final_L2, 1)) {
            key1_L2 = 0;
            result += `tam - FCAml = ${bufTam} mm  >=  tmin (Level 2) = ${bufTmin} mm </br>`;
          } else {
            key1_L2 = 1;
            result += `tam - FCAml = ${bufTam} mm  <  tmin (Level 2) = ${bufTmin} mm  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    } else {
      // === MAWP approach ===
      const MAWPr_C = this.calc_MAWPr_C_Level2_TypeB();
      const P_d_over_RSFa = Component_MAWP.sngP_d / RSFa;

      if (hasSupplementalLoads) {
        // Show separate lines for MAWPr_C, t_sl, MAWPr_L per spec
        const MAWPr_L2 = Math.min(MAWPr_C, this.sng_MAWPr_L > 0 ? this.sng_MAWPr_L : MAWPr_C);
        this.sng_MAWPr_L2 = MAWPr_L2;

        if (Component_MAWP.intUnit_select === 0) {
          const bufMawpC = MAWPr_C.toFixed(1);
          const bufPdRSFa = P_d_over_RSFa.toFixed(1);
          const bufTsl = this.sng_t_sl_calc.toFixed(3);
          const bufMawpL = this.sng_MAWPr_L > 0 ? this.sng_MAWPr_L.toFixed(1) : 'N/A';

          // Line 1: circumferential MAWPr_C vs P_d/RSFa
          if (MAWPr_C >= P_d_over_RSFa) {
            key1_L2 = 0;
            result += `MAWPr_C = ${bufMawpC} psi  >=  P_d/RSFa = ${bufPdRSFa} psi (Level 2) </br>`;
          } else {
            key1_L2 = 1;
            result += `MAWPr_C = ${bufMawpC} psi  <  P_d/RSFa = ${bufPdRSFa} psi (Level 2)  <font color="red">*Fail*</font> </br>`;
          }
          // Line 2: t_sl
          result += `Required shell thickness for supplemental loads, t_sl = ${bufTsl} inch </br>`;
          // Line 3: longitudinal MAWPr_L vs P_d/RSFa
          if (this.sng_MAWPr_L > 0) {
            if (this.sng_MAWPr_L >= P_d_over_RSFa) {
              result += `MAWPr_L = ${bufMawpL} psi  >=  P_d/RSFa = ${bufPdRSFa} psi (Level 2) </br>`;
            } else {
              if (key1_L2 === 0) key1_L2 = 1;
              result += `MAWPr_L = ${bufMawpL} psi  <  P_d/RSFa = ${bufPdRSFa} psi (Level 2)  <font color="red">*Fail*</font> </br>`;
            }
          }
        } else {
          const bufMawpC = MAWPr_C.toFixed(2);
          const bufPdRSFa = P_d_over_RSFa.toFixed(2);
          const bufTsl = this.sng_t_sl_calc.toFixed(1);
          const bufMawpL = this.sng_MAWPr_L > 0 ? this.sng_MAWPr_L.toFixed(2) : 'N/A';

          if (MAWPr_C >= P_d_over_RSFa) {
            key1_L2 = 0;
            result += `MAWPr_C = ${bufMawpC} MPa  >=  P_d/RSFa = ${bufPdRSFa} MPa (Level 2) </br>`;
          } else {
            key1_L2 = 1;
            result += `MAWPr_C = ${bufMawpC} MPa  <  P_d/RSFa = ${bufPdRSFa} MPa (Level 2)  <font color="red">*Fail*</font> </br>`;
          }
          result += `Required shell thickness for supplemental loads, t_sl = ${bufTsl} mm </br>`;
          if (this.sng_MAWPr_L > 0) {
            if (this.sng_MAWPr_L >= P_d_over_RSFa) {
              result += `MAWPr_L = ${bufMawpL} MPa  >=  P_d/RSFa = ${bufPdRSFa} MPa (Level 2) </br>`;
            } else {
              if (key1_L2 === 0) key1_L2 = 1;
              result += `MAWPr_L = ${bufMawpL} MPa  <  P_d/RSFa = ${bufPdRSFa} MPa (Level 2)  <font color="red">*Fail*</font> </br>`;
            }
          }
        }
      } else {
        // No supplemental loads - standard single-line display
        const MAWPr_L2 = MAWPr_C;
        this.sng_MAWPr_L2 = MAWPr_L2;

        if (Component_MAWP.intUnit_select === 0) {
          const bufMawp = MAWPr_L2.toFixed(1);
          const bufPd = P_d_over_RSFa.toFixed(1);
          if (MAWPr_L2 >= P_d_over_RSFa) {
            key1_L2 = 0;
            result += `MAWPr based on (tam - FCAml)/RSFa = ${bufMawp} psi  >=  P_d/RSFa = ${bufPd} psi (Level 2) </br>`;
          } else {
            key1_L2 = 1;
            result += `MAWPr based on (tam - FCAml)/RSFa = ${bufMawp} psi  <  P_d/RSFa = ${bufPd} psi (Level 2)  <font color="red">*Fail*</font> </br>`;
          }
        } else {
          const bufMawp = MAWPr_L2.toFixed(2);
          const bufPd = P_d_over_RSFa.toFixed(2);
          if (MAWPr_L2 >= P_d_over_RSFa) {
            key1_L2 = 0;
            result += `MAWPr based on (tam - FCAml)/RSFa = ${bufMawp} MPa  >=  P_d/RSFa = ${bufPd} MPa (Level 2) </br>`;
          } else {
            key1_L2 = 1;
            result += `MAWPr based on (tam - FCAml)/RSFa = ${bufMawp} MPa  <  P_d/RSFa = ${bufPd} MPa (Level 2)  <font color="red">*Fail*</font> </br>`;
          }
        }
      }
    }

    // Third criterion for Level 2 -- tam - FCAml >= tmin and (tmm >= 0.9 * tam or tmm - FCAml >= tmin)
    let key3_L2: number;
    if (Component_MAWP.intEquip !== 8) {
      let aa_k3 = 0.9 * GML_module.sngtam;
      let bb_k3 = LTA_module.sngtmm - CalcTemplate.sngFCAml;
      let cc_k3 = GML_module.sngtam - CalcTemplate.sngFCAml;

      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        aa_k3 = Utility.roundDouble(aa_k3, 3);
        bb_k3 = Utility.roundDouble(bb_k3, 3);
        cc_k3 = Utility.roundDouble(cc_k3, 3);

        let kk_L2 = Utility.roundDouble(this.sng_tmin_L2, 3);
        if (hasSupplementalLoads) {
          kk_L2 = Utility.roundDouble(this.sng_tmin_L2, 3);
        
        result += `tmin_Level_2 := max(tminC_Level_2, tminL_Level_2) = ${kk_L2.toFixed(3)} inch </br>`;
        }

        if (cc_k3 >= kk_L2) {
          if (LTA_module.sngtmm >= aa_k3) {
           // result +=
            //  "tam - FCAml = " + cc_k3.toFixed(3) +
            //  " inch >=  tmin (Level 2) and tmm >= 0.9 * tam = " + aa_k3.toFixed(3) +
             // " inch </br>";
            key3_L2 = 0;
          } else {
            if (bb_k3 >= kk_L2) {
              result +=
                "tam - FCAml = " + cc_k3.toFixed(3) +
                " inch >=  tmin (Level 2) and tmm - FCAml = " + bb_k3.toFixed(3) +
                " inch >= tmin (Level 2)  </br>";
              key3_L2 = 0;
            } else {
              result +=
                "tmm - FCAml = " + bb_k3.toFixed(3) +
                " inch <  tmin (Level 2) and tmm < 0.9 * tam = " + aa_k3.toFixed(3) +
                ` inch <font color="red">*Fail*</font> </br>`;
              key3_L2 = 1;
            }
          }
        }
      } else {
        // SI
        aa_k3 = Utility.roundDouble(aa_k3, 3);
        bb_k3 = Utility.roundDouble(bb_k3, 3);
        cc_k3 = Utility.roundDouble(cc_k3, 3);

        let kk_L2 = Utility.roundDouble(this.sng_tmin_L2, 3);

        result += `tmin,Level2 := max(tmin_C,Level2, tmin_L,Level2) = ${kk_L2.toFixed(1)} mm </br>`;

        if (cc_k3 >= kk_L2) {
          if (LTA_module.sngtmm >= aa_k3) {
            result += `tam - FCAml = ${cc_k3.toFixed(1)} mm >=  tmin (Level 2) and tmm >= 0.9 * tam = ${aa_k3.toFixed(1)} mm </br>`;
            key3_L2 = 0;
          } else {
            if (bb_k3 >= kk_L2) {
              result += `tam - FCAml = ${cc_k3.toFixed(1)} mm >=  tmin (Level 2) and tmm - FCAml = ${bb_k3.toFixed(1)} mm >= tmin (Level 2)  </br>`;
              key3_L2 = 0;
            } else {
              result += `tmm - FCAml = ${bb_k3.toFixed(1)} mm <  tmin (Level 2) and tmm < 0.9 * tam = ${aa_k3.toFixed(1)} mm <font color="red">*Fail*</font> </br>`;
              key3_L2 = 1;
            }
          }
        }
      }
    }

    // Second criterion for Level 2 -- tmm - FCAml >= max[0.5 * tmin (Level 2), t_lim]
    let key2_L2 = 1; // 0 = pass, 1 = fail
    let t_lim_L2: number;
    if (Component_MAWP.intEquip !== 6) {
      t_lim_L2 = 0.2 * Component_MAWP.sngtnom;
    } else {
      t_lim_L2 = 0.2 * Component_MAWP.sngtc;
    }

    if (Component_MAWP.intUnit_select === 0) {
      // US Customary
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        if (t_lim_L2 < 0.1) t_lim_L2 = 0.1;
      } else {
        if (t_lim_L2 < 0.05) t_lim_L2 = 0.05;
      }
    } else {
      // SI
      if (Component_MAWP.intEquip !== 5 && Component_MAWP.intEquip !== 6 && Component_MAWP.intEquip !== 7) {
        if (t_lim_L2 < 2.5) t_lim_L2 = 2.5;
      } else {
        if (t_lim_L2 < 1.3) t_lim_L2 = 1.3;
      }
    }

    if (Component_MAWP.intEquip !== 6) {
      // non-tank: max[0.5 * tmin (Level 2), t_lim]
      let aa_L2 = 0.5 * this.sng_tmin_L2;
      if (aa_L2 < t_lim_L2) aa_L2 = t_lim_L2;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        const bufTmm = (LTA_module.sngtmm - CalcTemplate.sngFCAml).toFixed(3);
        const bufMax = aa_L2.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa_L2) {
          key2_L2 = 0;
          result += `tmm - FCAml = ${bufTmm} inch  >=  max[0.5 * tmin (Level 2), t_lim] = ${bufMax} inch </br>`;
        } else {
          key2_L2 = 1;
          result += `tmm - FCAml = ${bufTmm} inch  <  max[0.5 * tmin (Level 2), t_lim] = ${bufMax} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        const bufTmm = (LTA_module.sngtmm - CalcTemplate.sngFCAml).toFixed(1);
        const bufMax = aa_L2.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa_L2) {
          key2_L2 = 0;
          result += `tmm - FCAml = ${bufTmm} mm  >=  max[0.5 * tmin (Level 2), t_lim] = ${bufMax} mm </br>`;
        } else {
          key2_L2 = 1;
          result += `tmm - FCAml = ${bufTmm} mm  <  max[0.5 * tmin (Level 2), t_lim] = ${bufMax} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    } else {
      // tank: max[0.6 * tmin (Level 2), t_lim]
      let aa_L2 = 0.6 * this.sng_tmin_L2;
      if (aa_L2 < t_lim_L2) aa_L2 = t_lim_L2;
      if (Component_MAWP.intUnit_select === 0) {
        // US Customary
        const bufTmm = (LTA_module.sngtmm - CalcTemplate.sngFCAml).toFixed(3);
        const bufMax = aa_L2.toFixed(3);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa_L2) {
          key2_L2 = 0;
          result += `tmm - FCAml = ${bufTmm} inch  >=  max[0.6 * tmin (Level 2), t_lim] = ${bufMax} inch </br>`;
        } else {
          key2_L2 = 1;
          result += `tmm - FCAml = ${bufTmm} inch  <  max[0.6 * tmin (Level 2), t_lim] = ${bufMax} inch  <font color="red">*Fail*</font> </br>`;
        }
      } else {
        // SI
        const bufTmm = (LTA_module.sngtmm - CalcTemplate.sngFCAml).toFixed(1);
        const bufMax = aa_L2.toFixed(1);
        if (LTA_module.sngtmm - CalcTemplate.sngFCAml >= aa_L2) {
          key2_L2 = 0;
          result += `tmm - FCAml = ${bufTmm} mm  >=  max[0.6 * tmin (Level 2), t_lim] = ${bufMax} mm </br>`;
        } else {
          key2_L2 = 1;
          result += `tmm - FCAml = ${bufTmm} mm  <  max[0.6 * tmin (Level 2), t_lim] = ${bufMax} mm  <font color="red">*Fail*</font> </br>`;
        }
      }
    }

    // Level 2 pass/fail message (based on slide 11 conditions)
    // Condition 1/2 = key1_L2, Condition 4 = key2_L2, Condition 5 = key3_L2
    if (key1_L2 === 0 && key2_L2 === 0 && key3_L2 !== 1) {
      Component_MAWP.strD_result = "Pass";
      result += '</br><font color="blue">General Metal Loss passed Level 2 assessment.</font> </br>';
    } else if (key3_L2 === 1) {
      Component_MAWP.strD_result = "Fail";
      result += '</br><font color="red">Consider performing a Level 3 Assessment.</font> </br>';
    } else if (key1_L2 !== 0 && key2_L2 === 0) {
      Component_MAWP.strD_result = "Fail";
      result += '</br><font color="red">Consider rerate or performing a Local Metal Loss or Level 3 Assessment.</font> </br>';
    } else {
      Component_MAWP.strD_result = "Fail";
      result += '</br><font color="red">General Metal Loss failed the Level 2 assessment. Consider performing a Level 3 or Local Metal Loss  Assessment.</font> </br>';
    }
  
    return result;
  }

  // ==================== End Level 2 Methods ====================

  public static GML_report(): string {
   // let report: string = "";

    //const format = "dd/MM/yyyy";
    //const locale = "en-US";
    //const dt1 = new Date();
    //const reportDate = formatDate(dt1, format, locale);
    
   //const component = this.getActiveReportComponent();
   //console.log('Generating report for component:', component);
    //report += this.getReportHeader(reportDate,component);
    //report += this.getReportBody(reportDate,component);

    //return report;
     return GMLReportService.generate();
  }

  private static getReportHeader(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP): string {
    let header: string = "";

    header +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 4</center>";
    header += "<center>Assessment of General Metal Loss</center></br></br>";

    header += reportDate + "</br>";
    header += "Page: 1</br></br></br>";

    const sRefinery: string = "Facility: ";
    const sPlant: string = "Plant: ";
    const sEquipment: string = "Equipment: ";
    const sAnalyst: string = "Analyst: ";

    header += sRefinery + Component_MAWP.strFacility + "</br>";
    header += sPlant + Component_MAWP.strPlant + "</br>";
    header += sEquipment + Component_MAWP.strEquipment + "</br>";
    header += sAnalyst + Component_MAWP.strAnalyst + "</br></br></br>";

    header += this.getReportList();

    return header;
  }

  private static getReportList(): string {
    return `  
        <ol class="appAndLimitList">  
          <li>The original design criteria were in accordance with a recognized code or standard.</li>  
          <li>The component is not operating in the creep range. The design temperature is less than or equal to the temperature limit in Table 4.1.</li>  
          <li>The region of metal loss has relatively smooth contours without notches, i.e. negligible local stress concentrations.</li>  
          <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
          <li>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:  
            <ol type="a" class="appAndLimitList">  
              <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
              <li>Spherical pressure vessels and storage spheres</li>  
              <li>Spherical, elliptical and torispherical formed heads</li>  
              <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
              <li>Cylindrical atmospheric storage tank shell courses</li>  
            </ol>  
          </li>  
        </ol>  
        </br>`;
  }

  private static getReportBody(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP
  ): string {
    let body: string = "";

    body += this.getComponentInformation(component);

    body += '<div class="pageBreak"></div>';

    // SECOND PAGE

    body += this.getSecondPageInformation(reportDate,component);

    body += "Assessment Results :</br></br>";
    body +=
      "All the conditions in the Applicability and Limitations section are met.</br></br>";

    body += this.gmlCalcResult;

    return body;
  }

  private static getComponentInformationUs(component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
    // US Customary
    if (component.intEquip != 8)
      report += `Design pressure or vessel MAWP (psi) = ${component.sngP_d.toFixed(
        1
      )}</br>`;
    else
      report += `Design Maximum Fill Height (ft) = ${CalcTemplate.sngMFH_d.toFixed(
        2
      )}</br>`;
    if (
      !Number.isNaN(Component_MAWP.sngTemp_d) &&
      Component_MAWP.sngTemp_d != -1
    )
      report += `Design temperature (deg-F) = ${Component_MAWP.sngTemp_d.toFixed(
        2
      )}</br>`;
    else report += "Design temperature (deg-F) = N/A</br>";
    // report += `Inside diameter corrected for FCA as applicable, D (inch) = ${Component_MAWP.sngID.toFixed(
    //   3
    // )}</br>`;
    //shameer - new requirement -start
    if (component.intEquip != 8){
    report += `Nominal Thickness (inch) = ${component.sngtnom.toFixed(
      3
    )}</br>`;
  }
    //shameer - new requirement -end
    if (component.intEquip != 8) {
      // non-tanks
      report += `Current measured (uniform) thickness, trd (inch) = ${component.sngtrd.toFixed(
        3
      )}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (inch) = ${component.sngFCA.toFixed(
        3
      )}</br>`;
    } else {
      report +=
        "Current measured (uniform) thickness, trd (inch) = N/A</br>";
      report +=
        "Future corrosion allowance, FCA = FCAi + FCAe (inch) = N/A</br>";
    }
    report += `Future corroded thickness, tc (inch) = ${component.sngtc.toFixed(
      3
    )}</br>`;
    report += `Minimum required thickness, tmin (inch) = ${component.sngtmin.toFixed(
      3
    )}</br>`;
    if (component.intEquip != 8) {
      report += `MAWP of the component based on tc, MAWP (psi) = ${Component_MAWP.sngMAWP.toFixed(
        1
      )}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (ft) = ${CalcTemplate.sngMFH.toFixed(
        2
      )}</br></br>`;
    }
    return report;
  }

   
  private static getComponentInformation(component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
   
    //shameer -start
    report += "</br>Type A Component Screening Result:</br>";
      // Use the active component's unit selection for labels
  const unitIsUs = component.intUnit_select == 0;

if(parseInt(localStorage.getItem("TypeAradioselection")) == 1) // for vertical popup
  {
    // for Vertical Vessel

        const userinputs = localStorage.getItem('verticalinputs');
        const Input_data = userinputs ? JSON.parse(userinputs) : null;
        const a1 = Input_data.inputvalue1;
        const a2 = Input_data.inputvalue2;

        if(component.intUnit_select == 0) //us customary
        {
        const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
        const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
        report += lbl1+a1+"</br>"+lbl2+a2;
      
        }
        else if(component.intUnit_select == 1) //si units
        {
        const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
        const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";             
        report += lbl1+a1+"</br>"+lbl2+a2;

        }

} 
 else if (parseInt(localStorage.getItem("TypeAradioselection")) == 2) //for horizontal popup
{
          //for Horizontal Vessel

          const userinputs = localStorage.getItem('horizontalinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;

          if(component.intUnit_select == 0) //us customary
          {
          const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
          const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
          report += lbl1+a1+"</br>"+lbl2+a2;

          }
          else if(component.intUnit_select == 1) //si units
          {
          const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
          const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
          report += lbl1+a1+"</br>"+lbl2+a2;

          }

}
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 3) //for Carbon and low alloy
{
          const userinputs = localStorage.getItem('carbonsteelinputs');
          const Input_data = userinputs ? JSON.parse(userinputs) : null;
          const a1 = Input_data.inputvalue1;
          const a2 = Input_data.inputvalue2;
           
          if(component.intUnit_select == 0) //us customary
             {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    report += lbl1+a1+"</br>"+lbl2+a2;

             }
         else if(component.intUnit_select == 1) //si units
             {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    report += lbl1+a1+"</br>"+lbl2+a2;
              
             }

}
else if(parseInt(localStorage.getItem("TypeAradioselection")) == 4) //for High alloy and Nonferrous
{
                //for High Alloy and Nonferrous Steel

              const userinputs = localStorage.getItem('highalloyinputs');
              const Input_data = userinputs ? JSON.parse(userinputs) : null;
              const a1 = Input_data.inputvalue1;
              const a2 = Input_data.inputvalue2;

              if(component.intUnit_select == 0) //us customary
              {
                const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                report += lbl1+a1+"</br>"+lbl2+a2;

              }
              else if(component.intUnit_select == 1) //si units
              {
                const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                report += lbl1+a1+"</br>"+lbl2+a2;
  
              }

}

    this.inttypeA_passorfail = parseInt(localStorage.getItem("TypeAPassorFail")) || 0;
    if(this.inttypeA_passorfail == 1)
    {
      report += "</br>The component meets the Type A screening criteria.</br></br>";
    }else if(this.inttypeA_passorfail == 0)
    {
      report += "</br>The component deosn't meet the Type A screening criteria.</br></br>";
    }

    //shameer -end
    report += "Component Information :</br></br>";
    //sooraj -start
    if (component.intEquip === 0)
      report += "Component type = Cylinder</br>";
    else if (component.intEquip === 1)
      report += "Component type = Cone</br>";
    else if (component.intEquip === 2)
      report += "Component type = Sphere</br>";
    else if (component.intEquip === 3)
      report += "Component type = Elliptical Head</br>";
    else if (component.intEquip === 4)
      report += "Component type = F&D Head</br>";
    else if (component.intEquip === 5)
      report += "Component type = B31.3 Piping</br>";
    else if (component.intEquip === 6)
      report += "Component type = B31.4 Piping</br>";
    else if (component.intEquip === 7)
      report += "Component type = B31.8 Piping</br>";
    else report += "Component type = Tank</br>";
    //sooraj -end
    
    if (component.intUnit_select == 0) {
      report += this.getComponentInformationUs(component);
    } else {
      report += this.getComponentInformationSi(component);
    }
    return report;
  }

  private static getComponentInformationSi(component: typeof Component_MAWP | typeof Component_MAEP) {
    let report: string = "";
    // SI

    if (component.intEquip != 8)
      report += `Design pressure or vessel MAWP (MPa) = ${component.sngP_d.toFixed(
        2
      )}</br>`;
    else
      report += `Design Maximum Fill Height (m) = ${CalcTemplate.sngMFH_d.toFixed(
        2
      )}</br>`;
    if (
      !Number.isNaN(Component_MAWP.sngTemp_d) &&
      Component_MAWP.sngTemp_d != -1
    )
      report += `Design temperature (deg-C) = ${Component_MAWP.sngTemp_d.toFixed(
        2
      )}</br>`;
    else report += "Design temperature (deg-C) = N/A</br>";
    // report += `Inside diameter corrected for FCA as applicable, D (mm) = ${Component_MAWP.sngID.toFixed(
    //   1
    // )}</br>`;

      //shameer - new requirement -start
      if (component.intEquip != 8){
        report += `Nominal Thickness (mm) = ${component.sngtnom.toFixed(
          3
        )}</br>`;
      }
        //shameer - new requirement -end
    if (component.intEquip != 8) {
      // non-tanks
      report += `Current measured (uniform) thickness, trd (mm) = ${component.sngtrd.toFixed(
        1
      )}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (mm) = ${component.sngFCA.toFixed(
        1
      )}</br>`;
    } else {
      report +=
        "Current measured (uniform) thickness, trd (mm) = N/A</br>";
      report += "Future corrosion allowance, FCA = FCAi + FCAe (mm) = N/A</br>";
    }
    report += `Future corroded thickness, tc (mm) = ${component.sngtc.toFixed(
      1
    )}</br>`;
    report += `Minimum required thickness, tmin (mm) = ${component.sngtmin.toFixed(
      1
    )}</br>`;
    if (component.intEquip != 8) {
      report += `MAWP of the component based on tc, MAWP (MPa) = ${Component_MAWP.sngMAWP.toFixed(
        2
      )}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (m) = ${CalcTemplate.sngMFH.toFixed(
        2
      )}</br></br>`;
    }
    return report;
  }
  private static getSecondPageInformation(reportDate: string,
    component: typeof Component_MAWP | typeof Component_MAEP): string {
    let report: string = "";
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 4</center>";
    report += "<center>Assessment of General Metal Loss</center></br></br>";

    report += reportDate + "</br>";
    report += "Page: 2</br></br></br>";

    report += `Longitudinal weld joint efficiency, E_L = ${Component_MAWP.sngE_L.toFixed(
      2
    )}</br>`;
    if (Component_MAWP.intEquip <= 1 || Component_MAWP.intEquip >= 5) {
      report += `Circumferential weld joint efficiency, E_C = ${Component_MAWP.sngE_c.toFixed(
        2
      )}</br>`;
    }
    report += `Allowable remaining strength factor, RSFa = ${CalcTemplate.sngRSF_a.toFixed(
      2
    )}</br></br></br>`;

    report += "Metal Loss Information :</br></br>";
    if (GML_module.intanalysis_type == 0)
      report += "Type of analysis = Average measured thickness</br>";
    else report += "Type of analysis = MAWP and MFH</br>";

    if (GML_module.intAssessmentLevel === 1) {
      report += "Level of Assessment = Level 1 and Level 2</br>";
    } else {
      report += "Level of Assessment = Level 1</br>";
    }

    if (Component_MAWP.intUnit_select == 0) {
      // US Customary
      report += `Average measured thickness, tam (inch) = ${GML_module.sngtam.toFixed(
        3
      )}</br>`;
      report += `Minimum measured thickness, tmm (inch) = ${LTA_module.sngtmm.toFixed(
        3
      )}</br>`;
      report += `Future corrosion allowance inside the damage area, FCAml (inch) = ${CalcTemplate.sngFCAml.toFixed(
        3
      )}</br></br></br>`;
    } else {
      // SI
      report += `Average measured thickness, tam (mm) = ${GML_module.sngtam.toFixed(
        1
      )}</br>`;
      report += `Minimum measured thickness, tmm (mm) = ${LTA_module.sngtmm.toFixed(
        1
      )}</br>`;
      report += `Future corrosion allowance inside the damage area, FCAml (mm) = ${CalcTemplate.sngFCAml.toFixed(
        1
      )}</br></br></br>`;
    }
    return report;
  }
}
